import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { ACTOR_ICON } from '../../EntityAuditHistory.config';
import {
  actorCellStyles,
  actorTextStyles,
  columnCellStyles,
  getActorAvatarStyles,
} from '../../EntityAuditHistory.styles';
import { EntityAuditHistoryTestIds } from '../../EntityAuditHistory.testIds';
import {
  ActorKind,
  getActorKind,
  getActorLabel,
  getActorSubline,
  getInitials,
} from '../../EntityAuditHistory.utils';

const AuditActorCell = ({ summary, actorNames = null }) => {
  const actorKind = getActorKind(summary);
  const isPerson = actorKind === ActorKind.HUMAN;
  const actorName = getActorLabel(summary, actorNames);
  const actorSubline = getActorSubline(summary, actorNames);
  const ActorIcon = ACTOR_ICON[actorKind];

  return (
    <Box data-testid={EntityAuditHistoryTestIds.ROW_ACTOR} sx={actorCellStyles}>
      <Box sx={getActorAvatarStyles(isPerson)}>
        {isPerson ? (
          <Typography component="span" variant="medium12">
            {getInitials(actorName)}
          </Typography>
        ) : (
          !!ActorIcon && <ActorIcon size={IconSize[16]} />
        )}
      </Box>

      <Box sx={actorTextStyles}>
        <Typography sx={columnCellStyles} variant="regular14">
          {actorName}
        </Typography>
        {!!actorSubline && (
          <Typography
            color="text.secondary"
            data-testid={EntityAuditHistoryTestIds.ROW_ACTOR_SUBLINE}
            sx={columnCellStyles}
            variant="regular12"
          >
            {actorSubline}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

AuditActorCell.propTypes = {
  summary: PropTypes.object.isRequired,
  actorNames: PropTypes.object,
};

export default AuditActorCell;
